<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true" :text="uploadMsg">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">Update Profile</template>
          <b-row v-if="user.photo" class="py-2 justify-content-md-center">
            <b-col cols="12" class="text-center">
              <img :src="baseURL+'/u/'+user.photo" width="auto" height="150px" />
            </b-col>
          </b-row>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="8">
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group label="First Name *">
                    <b-form-input
                      v-model="user.firstname"
                      type="text"
                      id="firstname"
                      placeholder="First Name"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group label="Last Name *">
                    <b-form-input
                      v-model="user.lastname"
                      type="text"
                      id="lastname"
                      placeholder="Last Name"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group label="Username *">
                    <b-form-input
                      v-model="user.username"
                      type="text"
                      id="username"
                      placeholder="username"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group label="Designation *">
                    <b-form-input
                      v-model="user.designation"
                      type="text"
                      id="designation"
                      placeholder="Designation"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group label="Phone Number">
                    <b-form-input
                      v-model="user.phone"
                      type="number"
                      id="email"
                      placeholder="Phone Number"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group label="Email *">
                    <b-form-input v-model="user.email" type="email" id="email" placeholder="Email"></b-form-input>
                  </b-form-group>
                </b-col>
                <!-- <b-col cols="12" md="6">
                  <b-form-group>
                    <label>Password *</label>
                    <b-form-input
                      v-model="user.password"
                      type="password"
                      id="password"
                      placeholder="••••••••"
                    ></b-form-input>
                  </b-form-group>
                </b-col>-->
                <b-col cols="12" md="6">
                  <b-form-group label="Role *">
                    <b-form-select v-model="user.role" :options="userTypes" :disabled="true"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="user.role=='Manager' || user.role=='Informant' || user.role=='Subscriber'"
                  cols="12"
                  md="6"
                >
                  <b-form-group label="Division *">
                    <b-form-select
                      :disabled="true"
                      v-model="division"
                      :options="divisions"
                      text-field="name"
                      value-field="_id"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col v-if="user.role=='Informant' || user.role=='Subscriber'" cols="12" md="6">
                  <b-form-group label="Range *">
                    <b-form-select
                      :disabled="true"
                      v-model="range"
                      :options="ranges"
                      text-field="name"
                      value-field="_id"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center text-center">
            <b-col cols="12">
              <img v-if="newImage" :src="newImage" width="auto" height="150px" />
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <b-col cols="12" md="6">
              <b-form-group label="Update Profile Picture">
                <b-form-file id="fileInput" :plain="false" v-model="image" @change="showImage"></b-form-file>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <span style="color:red">{{msg}}</span>
          </b-row>
          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button variant="outline-primary" size="sm" @click.prevent="inputCheck">Submit</b-button>
            </div>
          </b-row>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      msg: null,
      userTypes: [
        "SuperUser",
        "Researcher",
        "Manager",
        "Informant",
        "Subscriber"
      ],
      user: {
        firstname: null,
        lastname: null,
        username: null,
        email: null,
        // password: null,
        phone: null,
        designation: null,
        role: "Researcher"
      },
      division: null,
      range: null,
      divisions: [],
      ranges: [],
      image: null,
      uploadMsg: "",
      newImage: null
    };
  },
  beforeMount() {
    this.getData();
    this.getDivisions();
  },
  watch: {
    division: function(newvalue, oldvalue) {
      if (oldvalue != null && newvalue != oldvalue) {
        this.range = null;
      }
      this.getRanges(this.division);
    }
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/user/profile",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          id: this.$route.params.id
        }
      })
        .then(response => {
          this.appLoading = false;
          this.user = response.data.data;
          if (this.user.division) this.division = this.user.division._id;
          if (this.user.range) this.range = this.user.range._id;
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    getDivisions() {
      this.appLoading = true;
      axios({
        url: "/division/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          count: 0,
          page: 0
        }
      })
        .then(response => {
          this.appLoading = false;
          this.divisions = response.data.data;
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    getRanges(item) {
      this.appLoading = true;
      axios({
        url: "/range/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          count: 0,
          page: 0,
          division: item
        }
      })
        .then(response => {
          this.appLoading = false;
          this.ranges = response.data.data;
          if (this.ranges.length < 1) {
            if (
              this.user.role == "Informant" ||
              this.user.role == "Subscriber"
            ) {
              this.msg = "Please Add a range to the selected Division";
            }
          } else this.msg = null;
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    inputCheck() {
      this.msg = null;
      if (
        this.user.role == "Manager" ||
        this.user.role == "Informant" ||
        this.user.role == "Subscriber"
      ) {
        if (!this.division) {
          this.msg = "Please Select Division";
          return;
        }
      }
      if (this.user.role == "Informant" || this.user.role == "Subscriber") {
        if (!this.range) {
          this.msg = "Please Select Range";
          return;
        }
      }
      if (
        !this.user.firstname ||
        !this.user.username ||
        !this.user.email ||
        // !this.user.password ||
        !this.user.designation
      ) {
        this.msg = "Please Provide required Fields";
        return;
      } else this.editUser();
    },
    editUser() {
      this.appLoading = true;
      this.user.role = null;
      this.user.range = null;
      this.user.division = null;

      axios({
        method: "POST",
        url: "/user/edit",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: this.user
      })
        .then(response => {
          this.appLoading = false;
          if (response.data.status) {
            if (this.image) {
              this.uploadImage();
            } else {
              this.$router.go(-1);
            }
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch(err => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    showImage(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.newImage = null;
        return;
      }
      if (files[0].size > 5242880) {
        this.msg = "File size Should be less than 5MB";
        return;
      } else {
        this.msg = null;
      }
      var reader = new FileReader();
      reader.onload = e => {
        this.newImage = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },
    uploadImage() {
      var vm = this;
      this.appLoading = true;
      let formData = new FormData();
      formData.append("photo", this.image);
      axios({
        method: "POST",
        url: "/user/photo",
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token")
        },
        data: formData,
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          vm.uploadMsg = "Uploading " + percentCompleted + "%";
          // if (percentCompleted == 100) vm.uploadMsg = "";
        }
      })
        .then(response => {
          this.appLoading = false;
          this.$router.go(-1);
        })
        .catch(err => {
          this.ServerError = true;
        });
    }
  }
};
</script>
